<template>
  <div class="press">
    <template v-for="(item, i) in list">
      <div class="row" :key="i">
        <div class="img-list" :id="`gallery-${item.id}`">
          <template v-for="(img, imgIndex) in item.images">
            <a :href="`/${options.cdn}/${img}`" :data-sub-html="`${item.title}`" class="img hover-border" :key="imgIndex">
              <img :src="`/${options.cdn}/${img}`"/>
            </a>
          </template>
        </div>
        <div class="title">{{item.title}}</div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'press',
    components: {},
    data() {
      return {
        list: []
      }
    },
    computed: {
      ...mapState(['options'])
    },
    async mounted() {

      this.list = await this.axios.get('/press')

      this.list.forEach((item) => {
        this.$nextTick(() => {
          lightGallery(document.getElementById(`gallery-${item.id}`, {
            preload: 3,
            download: false
          }))
        })
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .press
    padding 0 100px

    .row
      margin-bottom 30px

      .title
        font-size 2.6rem
        font-family 'NeutraText-BoldItalicAlt'

      .img-list
        .img
          height 175px
          display inline-block
          margin-right 20px
          margin-bottom 20px
          font-size 0

          img
            width auto
            height 100%

  @media screen and (max-width: 768px)
    .press
      padding 0 20px

      .row
        .img-list
          .img
            width 100%
</style>
